module.exports = __webpack_public_path__ + "static/img/celoscope-35.2e8dc71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-35.jpg
// module id = L3OJ
// module chunks = 51